import dashboardChartTemplate from './dashboardChart.html';
import './dashboardChart.scss';

export default angular
  .module('main.dashboardPanel.dashboardChart', [])

  .directive('dashboardChart', () => {
    return {
      restrict: 'E',
      template: dashboardChartTemplate,
      scope: {
        series: '=', // data series array {data: {x: number, y: number}[], label: string}[]
        min: '=', // minimum axis value
        max: '=' // maximum axis value
      },
      controller: ($scope, $filter, $element) => {
        const $t = $filter('translate');

        let chart;

        init();

        function init() {
          $scope.$watch('series', () => {
            if ($scope.series) {
              drawChart();
            }
          }, true);


          $scope.$on('$destroy', function() {
            if (chart) {
              chart.destroy();
            }
          });
        }

        function drawChart() {
          if (!chart) {
            createChart();
          }

          $scope.showNoDataMessage = false;
          chart.data.datasets = chart.data.datasets || [];

          // Clear old data
          chart.data.datasets.forEach(ds => {
            ds.data = [];
          });

          // Apply input data to datasets
          $scope.series?.forEach((series, index) => {
            let dataset = chart.data.datasets[index];
            if (!dataset) {
              // create dataset if it was not created yet
              dataset = {};
              chart.data.datasets.push(dataset);
            }

            dataset.label = series.label;
            dataset.data = angular.copy(series.data || [])
              .filter((datum, index, arr) => { // Filter out multiple values for the same timestamp
                return !arr.some((d, i) => i > index && moment(datum.x).isSame(moment(d.x)));
              });
          });

          $scope.showNoDataMessage = !$scope.series || !$scope.series.length || $scope.series.every(s => !s.data || !s.data.length);

          let timeValues = $scope.series?.map(series => series.data.map(d => d.x)).flat();

          // Set min and max OX axis values
          chart.options.scales.xAxes[0].ticks.min = $scope.min || (timeValues?.length
            ? moment(Math.min(...timeValues)).startOf('d').valueOf()
            : undefined);
          chart.options.scales.xAxes[0].ticks.max = $scope.max || (timeValues?.length
            ? moment(Math.max(...timeValues)).endOf('d').valueOf()
            : undefined);

          chart.update();
        }

        function createChart() {
          let ctx = $($element).find('#dashboardChart')[0];
          let colorHover = 'rgba(142, 167, 218, 1)';
          let colorBlack = '#555';
          let fontFamily = '\'Roboto\', Arial, sans-serif';
          let gradient = ctx.getContext('2d').createLinearGradient(0, 0, 0, 400);
          gradient.addColorStop(0, 'rgba(196, 198, 202, 0.9)');
          gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');

          let gradient2 = ctx.getContext('2d').createLinearGradient(0, 0, 0, 400);
          gradient2.addColorStop(0, 'rgba(132, 166, 238, 0.9)');
          gradient2.addColorStop(1, 'rgba(255, 255, 255, 0)');

          Chart.defaults.global.defaultFontFamily = fontFamily;

          /* Custom interaction on hover */
          Chart.defaults.LineWithLine = Chart.defaults.line;
          Chart.controllers.LineWithLine = Chart.controllers.line.extend({
            draw: function(ease) {
              Chart.controllers.line.prototype.draw.call(this, ease);

              // Draw a line on hover
              if (this.chart.tooltip._active && this.chart.tooltip._active.length) {
                let activePoint = this.chart.tooltip._active[0],
                  ctx = this.chart.ctx,
                  x = activePoint.tooltipPosition().x,
                  y = activePoint.tooltipPosition().y,
                  topY = y + 8,
                  bottomY = this.chart.scales['y-axis-0'].bottom,
                  currentAlign = this.chart.options.tooltips.yAlign;

                // Dynamic positioning of the tooltip
                let align = y < 60 ? 'top' : 'bottom';
                if (currentAlign && currentAlign !== align) {
                  this.chart.options.tooltips.yAlign = align;
                  this.chart.update();
                }

                ctx.save();
                ctx.beginPath();
                ctx.moveTo(x, topY);
                ctx.lineTo(x, bottomY);
                ctx.lineWidth = 1;
                ctx.strokeStyle = colorHover;
                ctx.stroke();
                ctx.restore();
              }
            }
          });

          chart = new Chart(ctx, {
            type: 'LineWithLine',
            data: {
              datasets: [
                {
                  label: 'Data',
                  data: [],
                  lineTension: 0,

                  // Background
                  backgroundColor: gradient,

                  // Line
                  borderColor: 'rgba(190, 190, 190, 1)',
                  borderWidth: 2,

                  // Points
                  pointRadius: 6,
                  pointBorderWidth: 2,
                  pointBorderColor: 'rgba(170, 170, 170, 1)',
                  pointBackgroundColor: '#ffffff',
                  pointHoverRadius: 6,
                  pointHoverBorderColor: colorHover,
                  pointHoverBackgroundColor: '#ffffff',
                  pointHoverBorderWidth: 2,

                  spanGaps: true
                },
                {
                  label: 'Data 2',
                  data: [],
                  lineTension: 0,

                  // Background
                  backgroundColor: gradient2, // TODO

                  // Line
                  borderColor: 'rgb(78,115,255)', // TODO
                  borderWidth: 2,

                  // Points
                  pointRadius: 6,
                  pointBorderWidth: 2,
                  pointBorderColor: 'rgb(116,146,255)', // TODO
                  pointBackgroundColor: '#ffffff',
                  pointHoverRadius: 6,
                  pointHoverBorderColor: colorHover,
                  pointHoverBackgroundColor: '#ffffff',
                  pointHoverBorderWidth: 2,

                  spanGaps: true
                }
              ]
            },
            options: {
              layout: {
                padding: {
                  top: 10
                }
              },
              scales: {
                xAxes: [
                  {
                    type: 'time',
                    time: {
                      timezone: moment.tz.guess(),
                      unit: 'day',
                      parser: function(date) {
                        return moment(date).tz(moment.tz.guess()).subtract(12, 'h'); // shifting values 12h back to fit buggy grid lines
                      }
                    },
                    offset: true,
                    ticks: {
                      maxRotation: 0,
                      autoSkipPadding: 12
                    },
                    gridLines: {
                      borderDash: [4, 4],
                      zeroLineBorderDash: [4, 4],
                      drawTicks: true,
                      // NOTE: grid line offset making offset with equal steps before and after tick.
                      //  But our ticks are on 00:00 of the day! So grid lines are at the midday.
                      //  So we should shift values 12h back to fit grid lines
                      offsetGridLines: true,
                      color: 'rgba(0, 0, 0, 0.15)',
                      zeroLineColor: 'rgba(0, 0, 0, 0.15)'
                    }
                  }
                ],
                yAxes: [
                  {
                    ticks: {
                      maxTicksLimit: 6,
                      suggestedMin: 0,
                      callback: value => value % 1 === 0 ? value : undefined // skip non-whole values
                    },
                    gridLines: {
                      drawTicks: true,
                      drawBorder: true,
                      drawOnChartArea: false,
                      zeroLineColor: 'rgba(0, 0, 0, 0)',
                      borderDash: [0, 20],
                    }
                  }
                ]
              },
              legend: {
                display: false
              },
              hover: {
                mode: 'nearest',
                intersect: false
              },
              tooltips: {
                animationDuration: 0,
                caretPadding: 12,
                cornerRadius: 3,
                displayColors: $scope.series?.length > 1 ? true : false,
                backgroundColor: '#ffffff',
                borderColor: 'rgba(0,0,0,0.05)',
                borderWidth: 1,
                titleFontColor: colorBlack,
                bodyFontColor: colorBlack,
                xPadding: 12,
                yPadding: 8,
                xAlign: 'center',
                yAlign: 'bottom',

                // Hovering preference
                mode: 'nearest',
                intersect: false,

                callbacks: {
                  title: function(tooltipItems, data) {
                    let dataObj = data.datasets[tooltipItems[0].datasetIndex].data[tooltipItems[0].index];
                    let date = dataObj.x;
                    return moment(date).format('ll');
                  },
                  labelColor: function(tooltipItem, data) {
                    if (data.config.data.datasets?.length > 1) {
                      let dataObj = data.config.data.datasets[tooltipItem.datasetIndex];
                      return {
                        backgroundColor: dataObj.borderColor || dataObj.backgroundColor || '#ddd',
                        borderColor: '#ffffff'
                      }
                    }
                  }
                }
              },
              animation: {
                duration: 300
              }
            }
          });
        }
      }
    };
  })
  .name;
